module.exports = __webpack_public_path__ + "static/media/fade03.6dabee6e.png";